import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";
import PageHero from "@/components/PageHero";
import Reveal from "@/components/Reveal";
import { SECTEURS, IMAGES } from "@/data/site";

const IMG = [IMAGES.boutique, IMAGES.gala];

export default function Secteurs() {
  return (
    <>
      <Seo title="Secteurs d'activité" description="Retail, luxe, tech, finance, automobile, immobilier : Désir Events maîtrise les codes de chaque industrie pour des événements sur-mesure." path="/secteurs" />
      <PageHero
        eyebrow="Secteurs d'activité"
        title={<>Nous parlons<br />la langue de <span className="italic text-lime-dim">votre marché.</span></>}
        subtitle="Chaque industrie possède ses codes et ses attentes. Notre force : les maîtriser pour créer des événements parfaitement alignés."
      />

      <section className="mx-auto max-w-[1440px] px-5 py-20 md:px-10 md:py-28">
        <div className="grid auto-rows-[minmax(0,1fr)] gap-4 md:grid-cols-6">
          {SECTEURS.map((sec, i) => {
            const spans = ["md:col-span-4", "md:col-span-2", "md:col-span-2", "md:col-span-4", "md:col-span-3", "md:col-span-3"];
            const withImg = i === 0 || i === 3;
            return (
              <Reveal key={sec.name} delay={i % 3} className={spans[i]}>
                <div className="group relative h-full min-h-[220px] overflow-hidden rounded-2xl border border-ink/10 bg-white p-8 transition-colors duration-500 hover:border-lime-dim/50" data-testid={`secteur-card-${i}`}>
                  {withImg && (
                    <>
                      <img src={IMG[i === 0 ? 0 : 1]} alt={sec.name} className="absolute inset-0 h-full w-full object-cover opacity-100 transition-transform duration-700 group-hover:scale-105" />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/30 to-black/10" />
                    </>
                  )}
                  <div className="relative z-10 flex h-full flex-col justify-between">
                    <span className={`font-serif text-2xl ${withImg ? "text-white/50" : "text-ink/25"}`}>0{i + 1}</span>
                    <div>
                      <h3 className={`font-serif text-3xl font-medium md:text-4xl ${withImg ? "text-white" : "text-ink group-hover:text-lime-dim"}`}>{sec.name}</h3>
                      <p className={`mt-3 max-w-md text-sm leading-relaxed ${withImg ? "text-white/80" : "text-ink/60"}`}>{sec.desc}</p>
                    </div>
                  </div>
                </div>
              </Reveal>
            );
          })}
        </div>

        <Reveal delay={1}>
          <div className="mt-16 flex flex-col items-start justify-between gap-6 rounded-2xl border border-ink/10 bg-lime p-10 text-ink md:flex-row md:items-center">
            <div>
              <span className="text-[11px] uppercase tracking-[0.28em] text-ink/60">Votre secteur n'est pas listé ?</span>
              <p className="mt-2 font-serif text-3xl font-medium md:text-4xl">Parlons-en directement.</p>
            </div>
            <Link to="/devis" className="inline-flex items-center gap-2 rounded-full bg-ink px-7 py-3.5 text-sm font-medium text-white transition-transform duration-300 hover:scale-105">Déposer mon brief <ArrowRight size={16} /></Link>
          </div>
        </Reveal>
      </section>
    </>
  );
}
